import { Currency } from './globals/currency'

export type AlternativeVehicle = Nullable<{
  year: number
  manufacturer: string
  model: string
  serialNumber: string
  type: PropsTypesOf<typeof AlternativeVehicleTypeEnum>['code']
}> & {
  amount: Currency
}

function load(model?: Partial<AlternativeVehicle> | null): AlternativeVehicle {
  return {
    year: model?.year ?? null,
    manufacturer: model?.manufacturer ?? null,
    model: model?.model ?? null,
    serialNumber: model?.serialNumber ?? null,
    amount: model?.amount ?? Currency.load(),
    type: model?.type ?? null,
  }
}

export const AlternativeVehicleTypeEnum = {
  Bicicleta: { label: 'Bicicleta', code: 'Bike' },
  Scooter: { label: 'Scooter', code: 'Scooter' },
  Patn: { label: 'Patín', code: 'RollerSkate' },
  Silla_de_ruedas: { label: 'Silla de ruedas', code: 'Wheelchair' },
  Jet_Ski: { label: 'Jet Ski', code: 'JetSki' },
} as const

function getTypeList() {
  return Object.values(AlternativeVehicleTypeEnum)
}

export const AlternativeVehicle = {
  load,
  getTypeList,
}
